// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import FormPrimaryMessage from './FormPrimaryMessage';

// Utils
import { useErrorTranslator } from '../../../utils/errorTranslation';

// Styles
import './PrimaryErrorMessage.scss';

const PrimaryErrorMessage = ({ message, error, show, children, icon = 'cross-small' }) => {
    const translateError = useErrorTranslator();

    // Prioritize error object over message string
    const displayMessage = error ? translateError(error) : message;

    return (
        <FormPrimaryMessage className="PrimaryErrorMessage" message={displayMessage} show={show} icon={icon}>
            {children}
        </FormPrimaryMessage>
    );
};

PrimaryErrorMessage.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    error: PropTypes.object,
    show: PropTypes.bool,
    icon: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default PrimaryErrorMessage;
